import { handleActions } from 'redux-actions';

import { followUpModalActions } from '../actions/followUpModal';

export type FollowUpModalState = {
  ui: {
    isModalShown: boolean;
    queueSelection: boolean;
  };
  timestamp: string | null;
  csid: string | null;
};

export const initialState: FollowUpModalState = {
  ui: {
    isModalShown: false,
    queueSelection: false,
  },
  timestamp: null,
  csid: null,
};

export const { followUpModalOpen, followUpModalClose } = followUpModalActions;

const reducer = handleActions<FollowUpModalState, any>(
  {
    // Show follow-up modal.
    [followUpModalOpen.toString()]: (state: FollowUpModalState, action) => {
      const { csid, conversationQueueId, timestamp, queueSelection } =
        action.payload;

      return {
        ...state,
        ui: { ...state.ui, isModalShown: true, queueSelection },
        timestamp,
        csid,
        conversationQueueId,
      };
    },

    // Hide follow-up modal.
    [followUpModalClose.toString()]: (state: FollowUpModalState, action) => {
      return initialState;
    },
  },
  initialState,
);

export default reducer;
